import {RiskView} from "../risk/list";

export class OpportunityView extends RiskView{

    showOpportunity = true;

}